import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('atc_cookie_consent');
    if (!consent) setVisible(true);
  }, []);

  const handleChoice = (choice) => {
    localStorage.setItem('atc_cookie_consent', choice);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          className="fixed bottom-0 left-0 right-0 z-50 bg-[#003057] text-white p-5 shadow-2xl"
          data-testid="cookie-banner"
        >
          <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center gap-4 justify-between">
            <p className="text-sm text-gray-200 max-w-2xl">
              We use essential cookies to make our site work. With your consent we also use non-essential
              analytics cookies to improve your experience. See our{' '}
              <Link to="/cookie-policy" className="text-[#00A3E0] underline">Cookie Policy</Link>.
            </p>
            <div className="flex gap-3 flex-shrink-0">
              <button
                onClick={() => handleChoice('essential')}
                className="px-5 py-2 border border-white/40 text-white rounded text-sm font-semibold hover:bg-white/10"
                data-testid="cookie-reject"
              >
                Essential Only
              </button>
              <button
                onClick={() => handleChoice('all')}
                className="px-5 py-2 bg-[#0089D0] text-white rounded text-sm font-semibold hover:bg-[#00A3E0]"
                data-testid="cookie-accept"
              >
                Accept All
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieConsent;
